import { render } from "./Voters.vue?vue&type=template&id=cff7a69a&scoped=true"
import script from "./Voters.vue?vue&type=script&lang=ts"
export * from "./Voters.vue?vue&type=script&lang=ts"

import "./Voters.vue?vue&type=style&index=0&id=cff7a69a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cff7a69a"

export default script